import { Action, defaultActions } from '#/common/components/DataGrid';
import { WorkOrderItem } from '#/graphql/types';

export const actions: Action<WorkOrderItem>[] = [...defaultActions];
